module.exports = __webpack_public_path__ + "static/img/bridge.bcc27a0b.png";